/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoGoogleStorePurchaseLogListListData model module.
 * @module model/LogControllerDtoGoogleStorePurchaseLogListListData
 * @version 1.0
 */
class LogControllerDtoGoogleStorePurchaseLogListListData {
    /**
     * Constructs a new <code>LogControllerDtoGoogleStorePurchaseLogListListData</code>.
     * @alias module:model/LogControllerDtoGoogleStorePurchaseLogListListData
     */
    constructor() { 
        
        LogControllerDtoGoogleStorePurchaseLogListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoGoogleStorePurchaseLogListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoGoogleStorePurchaseLogListListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoGoogleStorePurchaseLogListListData} The populated <code>LogControllerDtoGoogleStorePurchaseLogListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoGoogleStorePurchaseLogListListData();

            if (data.hasOwnProperty('purchaseNo')) {
                obj['purchaseNo'] = ApiClient.convertToType(data['purchaseNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
            if (data.hasOwnProperty('productType')) {
                obj['productType'] = ApiClient.convertToType(data['productType'], 'Number');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'String');
            }
            if (data.hasOwnProperty('orderId')) {
                obj['orderId'] = ApiClient.convertToType(data['orderId'], 'String');
            }
            if (data.hasOwnProperty('purchaseToken')) {
                obj['purchaseToken'] = ApiClient.convertToType(data['purchaseToken'], 'String');
            }
            if (data.hasOwnProperty('purchaseTime')) {
                obj['purchaseTime'] = ApiClient.convertToType(data['purchaseTime'], 'Date');
            }
            if (data.hasOwnProperty('purchaseStatus')) {
                obj['purchaseStatus'] = ApiClient.convertToType(data['purchaseStatus'], 'Number');
            }
            if (data.hasOwnProperty('validationMessage')) {
                obj['validationMessage'] = ApiClient.convertToType(data['validationMessage'], 'String');
            }
            if (data.hasOwnProperty('regionCode')) {
                obj['regionCode'] = ApiClient.convertToType(data['regionCode'], 'String');
            }
            if (data.hasOwnProperty('consumedState')) {
                obj['consumedState'] = ApiClient.convertToType(data['consumedState'], 'Number');
            }
            if (data.hasOwnProperty('developerPayload')) {
                obj['developerPayload'] = ApiClient.convertToType(data['developerPayload'], 'String');
            }
            if (data.hasOwnProperty('itemList')) {
                obj['itemList'] = ApiClient.convertToType(data['itemList'], 'String');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('refundedAt')) {
                obj['refundedAt'] = ApiClient.convertToType(data['refundedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoGoogleStorePurchaseLogListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoGoogleStorePurchaseLogListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['productId'] && !(typeof data['productId'] === 'string' || data['productId'] instanceof String)) {
            throw new Error("Expected the field `productId` to be a primitive type in the JSON string but got " + data['productId']);
        }
        // ensure the json data is a string
        if (data['orderId'] && !(typeof data['orderId'] === 'string' || data['orderId'] instanceof String)) {
            throw new Error("Expected the field `orderId` to be a primitive type in the JSON string but got " + data['orderId']);
        }
        // ensure the json data is a string
        if (data['purchaseToken'] && !(typeof data['purchaseToken'] === 'string' || data['purchaseToken'] instanceof String)) {
            throw new Error("Expected the field `purchaseToken` to be a primitive type in the JSON string but got " + data['purchaseToken']);
        }
        // ensure the json data is a string
        if (data['validationMessage'] && !(typeof data['validationMessage'] === 'string' || data['validationMessage'] instanceof String)) {
            throw new Error("Expected the field `validationMessage` to be a primitive type in the JSON string but got " + data['validationMessage']);
        }
        // ensure the json data is a string
        if (data['regionCode'] && !(typeof data['regionCode'] === 'string' || data['regionCode'] instanceof String)) {
            throw new Error("Expected the field `regionCode` to be a primitive type in the JSON string but got " + data['regionCode']);
        }
        // ensure the json data is a string
        if (data['developerPayload'] && !(typeof data['developerPayload'] === 'string' || data['developerPayload'] instanceof String)) {
            throw new Error("Expected the field `developerPayload` to be a primitive type in the JSON string but got " + data['developerPayload']);
        }
        // ensure the json data is a string
        if (data['itemList'] && !(typeof data['itemList'] === 'string' || data['itemList'] instanceof String)) {
            throw new Error("Expected the field `itemList` to be a primitive type in the JSON string but got " + data['itemList']);
        }

        return true;
    }


}



/**
 * @member {Number} purchaseNo
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['purchaseNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} productNo
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['productNo'] = undefined;

/**
 * @member {Number} productType
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['productType'] = undefined;

/**
 * @member {String} productId
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['productId'] = undefined;

/**
 * @member {String} orderId
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['orderId'] = undefined;

/**
 * @member {String} purchaseToken
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['purchaseToken'] = undefined;

/**
 * @member {Date} purchaseTime
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['purchaseTime'] = undefined;

/**
 * @member {Number} purchaseStatus
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['purchaseStatus'] = undefined;

/**
 * @member {String} validationMessage
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['validationMessage'] = undefined;

/**
 * @member {String} regionCode
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['regionCode'] = undefined;

/**
 * @member {Number} consumedState
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['consumedState'] = undefined;

/**
 * @member {String} developerPayload
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['developerPayload'] = undefined;

/**
 * @member {String} itemList
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['itemList'] = undefined;

/**
 * @member {Number} postNo
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['postNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['updatedAt'] = undefined;

/**
 * @member {Date} refundedAt
 */
LogControllerDtoGoogleStorePurchaseLogListListData.prototype['refundedAt'] = undefined;






export default LogControllerDtoGoogleStorePurchaseLogListListData;

